import Cookies from 'js-cookie';

export const setAuthenticated = (expiresIn) => {
  const expires = new Date(new Date().getTime() + expiresIn * 1000);
  Cookies.set('authenticated', true, { expires });
  window.location.reload();
};

export const removeAuthenticated = () => {
  Cookies.remove('authenticated');
  localStorage.removeItem('lastSpaceId');
  window.location.reload();
};

export const isAuthenticated = () => {
  return Cookies.get('authenticated') === 'true';
};
